// dataimportTemplateFieldMappingService.js
import { client } from "../../../api/client";

const BASE = process.env.REACT_APP_GATEWAY_URI; // e.g., https://gateway.example.com/
const RESOURCE = "templatesapi/importtemplatefieldmapping";

/** LIST (your existing function, unchanged) */
export const fetchImportTemplateFieldMappingService = async () => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_importTemplateFieldMappingData.json");
  } else {
    try {
      const response = await client.get(BASE, RESOURCE);
      return response.data;
    } catch (error) {
      console.error("Error fetching import template field mapping:", error);
      return [];
    }
  }
};

/** GET BY ID */
export const getImportTemplateFieldMappingService = async (id) => {
  try {
    const response = await client.get(BASE, `${RESOURCE}/${id}`);
    return response.data ?? null; // null if not found (controller returns 404)
  } catch (error) {
    if (error?.response?.status === 404) return null;
    console.error(`Error getting import template field mapping ${id}:`, error);
    throw error;
  }
};

/** CREATE (expects DTO shaped for your controller) */
export const createImportTemplateFieldMappingService = async (dto) => {
  try {
    const response = await client.post(BASE, RESOURCE, dto);
    // Controller returns 201 with { Message, importTemplateFieldMappingDTO }
    return response.data;
  } catch (error) {
    console.error("Error creating import template field mapping:", error);
    throw error;
  }
};

/** UPDATE (204 No Content on success) */
export const updateImportTemplateFieldMappingService = async (id, dto) => {
  try {
    const response = await client.put(BASE, `${RESOURCE}/${id}`, dto);
    return { ok: response.status === 204, status: response.status };
  } catch (error) {
    const status = error?.response?.status ?? 500;
    console.error(`Error updating import template field mapping ${id}:`, error);
    return { ok: false, status };
  }
};

/** DELETE (soft-delete on server; 204 No Content) */
export const deleteImportTemplateFieldMappingService = async (id) => {
  try {
    const response = await client.delete(BASE, `${RESOURCE}/${id}`);
    return { ok: response.status === 204, status: response.status };
  } catch (error) {
    const status = error?.response?.status ?? 500;
    console.error(`Error deleting import template field mapping ${id}:`, error);
    return { ok: false, status };
  }
};
